resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*

    Formatters

        Static class that contains data formatters.

        Example Usage:
            Formatters.formatPhone("6043211234");
*/
var Formatters = {
  /*
      Helper method to convert the isoDateString to a Javascript date object,
      Discards any time zone designation information at the end the the string

      Arguments:
         isoDateString [string] (required):
            Assumes that the format of the string will be as such "2017-04-21T08:00:00.000-07:00"
      Returns:
        Javascript Date object agnostic of the user's local timezone for the specified ISO date string
        If the string is empty or does not satisfy the expected format then the current date time
    */
  formatTimezone: function (isoDateString) {
    var result = new Date();
    if (isoDateString && isoDateString.length >= 24) {
      var year = isoDateString.substring(0, 4),
        month = parseInt(isoDateString.substring(5, 7)) - 1, // starting at 0
        date = isoDateString.substring(8, 10),
        hours = isoDateString.substring(11, 13),
        minutes = isoDateString.substring(14, 16),
        seconds = isoDateString.substring(17, 19),
        milliseconds = isoDateString.substring(20, 23);

      result = new Date(year, month, date, hours, minutes, seconds, milliseconds);
    }
    return result;
  },

  /*
        Formats the phone number in the format (###) ### ####

        Arguments:
            data [string] (required):
                The data to be formatted.

        Returns:
            The formatted phone number.
    */
  formatPhone: function (data) {
    if (data == null) return null;

    data = data.replace(/[^\d.]/g, '');

    if (data.length == 10) {
      data =
        '(' + data.substring(0, 3) + ')' + ' ' + data.substring(3, 6) + '-' + data.substring(6, 10);
    }

    return data;
  },

  /*
        Formats the value in the format $#,###,###.## with the currency symbol and cents portion being optional

        Arguments:
            data [string] (required):
                The data to be formatted.
            settingsObj [object]:
                Settings object with the following properties:
                    noCurrencySymbol [boolean]:
                        Return the money string without the preceeding "$"
                    optionalDecimals [boolean]:
                        If the money quantity has no decimal part, don't include the cents (".XX") portion
                    decomposeResult [boolean]:
                        Return the money amount as an array of two strings: a dollars portion and a cents portion
                    separateDollarSign [boolean]:
                        Split out the dollar sign as an array item

        Returns:
            The formatted money string.
    */
  
  formatMoney: function (data, settingsObj) {
    settingsObj = settingsObj || {};

    var sign, parts, currency, dollars, cents, dateResult;

    data = data.toString();
    
    // determine sign of quantity
    sign = data.charAt(0) === '-' ? '- ' : '';
    
    // strip all characters except numbers and decimals
    data = data.replace(/[^\d.]/g, '');
    data = data.search(/\d/) === -1 ? '0' : data;
    
    // add cents portion if it is missing
    // otherwise limit to 2 decimal places
    data = data.indexOf('.') >= 0 ? parseFloat(data).toFixed(2).toString() : data += '.00';
    
    // split into dollar and cents portions
    parts = data.toString().split('.');
    
    // add "$" if required
    currency = settingsObj.noCurrencySymbol ? '' : '$';

    // add commas to dollar portion
    dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    cents = parts[1];
    
    if (settingsObj.separateDollarSign) {
      dateResult = [sign, currency, dollars, cents];
    } else {
      dateResult = [[sign, currency, dollars].join(''), cents];
    }

    // remove cents portion if required
    if (settingsObj.optionalDecimals && dateResult[dateResult.length - 1] === '00') {
      dateResult.pop();
    }

    // if decomposing result, return date as array
    // otherwise return as single string
    return settingsObj.decomposeResult ? dateResult : dateResult.join('.');
  },

  /*
        Formats a string singular or plural based on the given interger

        Arguments:
            string [string] (required):
                The string to format. Should be singular.
            int [interger] (required):
                The value preceding the string, determines correct format

        Returns:
            The formatted date string.
    */
  formatSingularPluralString: function (int, string) {
    var result;
    switch (int) {
      case 1:
        result = int + ' ' + string;
        break;
      default:
        result = int + ' ' + string + 's';
    }
    return result;
  }
};
